import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const InvoicesSummaryWrapper = styled.section`
  margin-bottom: ${Spacing.S32};
`
